<template>
  <Modal
    v-model="isVisible"
    title="创建补发商品包裹"
    :mask-closable="false"
    width="900px"
    class-name="reissue-commodity"
  >
    <div class="modal-body-main">
      <Form ref="reissueFormRef" :model="formData" :rules="ruleDetails" class="reissue-commodity-form">
        <Table
          class="mt10"
          highlight-row
          border
          :height="500"
          :loading="tableLoading"
          :columns="tableColumn"
          :data="formData.talbeData"
        >
          <template slot-scope="{row, index}" slot="salesRecordNumber">
            <div class="row-col-info grid-vertical-center">
              <div>
                <div>SKU：{{ row.sku }}</div>
                <div>商品名称：{{ row.title }}</div>
                <div>规格：
                  <template v-if="row.variationList">
                    <span v-for="(vItem, vIndex) in row.variationList" :key="`${vIndex}`">
                      <span>{{vItem.name}}: </span>
                      <span>{{vItem.value}}</span>
                    </span>
                  </template>
                </div>
              </div>
              <div class="product-sku-number">X {{ $common.isEmpty(Number(row.quantity)) ? '0' : row.quantity }}</div>
            </div>
          </template>
          <template slot-scope="{row, index}" slot="reissueTotal">
            <Form-item
              label=""
              :label-width="0"
              :prop="`talbeData.${index}.reissueTotal`"
              class="mt25"
              :rules="tableValidate.reissueTotal"
            >
              <Input v-model="formData.talbeData[index].reissueTotal" placeholder="请输入补发数量" />
            </Form-item>
          </template>
        </Table>
      </Form>
      <Spin fix v-if="pageLoading">{{ pageLoadTxt }}</Spin>
    </div>
    <div slot="footer">
      <Button @click="closeModal">取消</Button>
      <Button type="primary" @click="createPackage" :loading="pageLoading">创建包裹</Button>
    </div>
  </Modal>
</template>
<script>
import api from '@/api/api';

export default {
  name: "buyerOrderHistory",
  components: {},
  mixins: [],
  props: {
    modelVisible: {
      type: Boolean,
      default: false
    },
    moduleData: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      isVisible: false,
      pageLoading: false,
      tableLoading: false,
      pageDetails: {},
      pageLoadTxt: '正在加载数据中...',
      shippingMethodValue: [],
      formData: {
        talbeData: [],
      },
      ruleDetails: {},
      tableValidate: {
        reissueTotal: [
          { required: true, validator: this.$common.validatorMaxNumber, min: 0, point: 0, msg: '请输入不小于0的整数', trigger: 'blur' },
          { required: true, validator: this.$common.validatorMaxNumber, min: 0, point: 0, msg: '请输入不小于0的整数', trigger: 'change' },
        ]
      },
      cancelList: [],
      tableColumn: [
        {
          title: '应发数量',
          slot: 'salesRecordNumber',
          align: 'center',
          minWidth: 300,
        },
        {
          title: '已发数量',
          key: 'sentTotal',
          align: 'center',
          width: 120,
        },
        {
          title: '补发数量',
          slot: 'reissueTotal',
          align: 'center',
          width: 200,
        },
      ],
    };
  },
  watch: {
    modelVisible (newVal) {
      this.isVisible = newVal;
      this.$nextTick(() => {
        newVal && this.iniaData();
      })
    },
    isVisible (newVal) {
      this.$emit('update:modelVisible', newVal);
      !newVal && this.closeModal();
    }
  },
  computed: {
    // SKU 对应的数据
    skuData () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.skuData)) return [];
      let newArr = [];
      // let newKey = '';
      Object.keys(this.moduleData.skuData).forEach(key => {
        // newKey = `${this.moduleData.skuData[key].sku}${key}`;
        newArr.push(this.moduleData.skuData[`${key}`]);
      });
      newArr = this.$common.flat(newArr);
      return newArr;
    },
    // 已发货的包裹
    sentPackage () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.sentPackage)) return [];
      return this.moduleData.sentPackage;
    },
    // 对应 sku 发货数量
    skuSentNumber () {
      let obj = {};
      let pKey = '';
      this.sentPackage.forEach(page => {
        if (!this.$common.isEmpty(page.orderShippingDetailList)) {
          //  匹配数据中的 `${item.sku}${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
          page.orderShippingDetailList.forEach(item => {
            pKey = `${item.sku}${item.webstoreItemId || ''}${item.webstoreOrderTransactionId || ''}`;
            if (this.$common.isUndefined(obj[pKey])) {
              obj[pKey] = 0;
            }
            if (!this.$common.isEmpty(Number(item.quantity))) {
              obj[pKey] += Number(item.quantity);
            }
          });
        }
      });
      return obj;
    },
    // 订单信息
    orderInfo () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.orderInfo)) return {};
      return this.moduleData.orderInfo;
    },
    // 订单详情
    orderDetails () {
      if (this.$common.isEmpty(this.moduleData) || this.$common.isEmpty(this.moduleData.orderDetails)) return {};
      return this.moduleData.orderDetails;
    },
  },
  created () {},
  methods: {
    // 获取数据
    iniaData () {
      this.pageLoading = true;
      let beforeRes = [];
      this.$common.promiseAll(beforeRes).finally(() => {
        this.$common.promiseAll([]).finally(() => {
          let dataList = this.$common.copy(this.skuData);
          let setNumber = 0;
          let pKey = '';
          dataList.forEach((row) => {
            setNumber = 0;
            row.sentTotal = 0; // 已发数量
            row.unsentTotal = 0; // 未发数量
            row.reissueTotal = 0; // 补发数量
            // 默认 平台信息
            // row.orderTransactionId = `${row.webstoreOrderTransactionId},${row.webstoreItemId || row.webstoreSku || ''}`;
            //  匹配数据中的 `${row.sku}${row.webstoreItemId || ''}${row.webstoreOrderTransactionId || ''}`;
            pKey = `${row.sku}${row.webstoreItemId || ''}${row.webstoreOrderTransactionId || ''}`;
            if (!this.$common.isEmpty(this.skuSentNumber[pKey])) {
              setNumber = this.skuSentNumber[pKey];
            }
            if (!this.$common.isEmpty(Number(row.quantity)) && Number(row.quantity) > 0) {
              row.sentTotal = setNumber;
              row.unsentTotal = Number(row.quantity) - setNumber;
              row.reissueTotal = Number(row.quantity) - setNumber;
            }
          });
          let newTableObj = {};
          // 再次遍历，合并相同的 sku
          dataList.forEach((row) => {
            if (this.$common.isEmpty(newTableObj[row.sku])) {
              newTableObj[row.sku] = this.$common.copy(row);
            } else {
              newTableObj[row.sku].quantity += row.quantity;
              newTableObj[row.sku].sentTotal += row.sentTotal;
              newTableObj[row.sku].unsentTotal += row.unsentTotal;
              newTableObj[row.sku].reissueTotal += row.reissueTotal;
            }
          });
          this.formData.talbeData = Object.values(newTableObj);
          this.pageLoading = false;
        })
      })
    },
    // 创建包裹
    createPackage () {
      if (this.pageLoading) return;
      this.$refs.reissueFormRef.validate((valid) => {
        if (!valid) {
          this.$common.inputFocus('reissue-commodity-form');
          return;
        }
        this.pageLoading = true;
        this.pageLoadTxt = '正在保存数据，请不要关闭窗口以免保存失败';
        const paramsData = this.packageDataHand();
        const validData = this.validFromData(paramsData);
        if (!validData) {
          this.pageLoading = false;
          return;
        }
        this.axios.post(api.create_newPackage, paramsData).then(res => {
          if (res && res.data && res.data.code === 0) {
            this.$Message.success('操作成功');
            this.$emit('updateOrderData', true);
            this.closeModal();
          } else {
            this.$Message.error('操作失败，请重新尝试');
          }
          this.pageLoading = false;
        }).catch(() => {
          this.pageLoading = false;
        });
      })
    },
    // 包裹数据处理
    packageDataHand () {
      let obj = {};
      obj.addType = 1;
      obj.buyerAccountId = this.orderInfo.buyerAccountId;
      obj.buyerAddress1 = this.orderInfo.buyerAddress1;
      obj.buyerAddress2 = this.orderInfo.buyerAddress2;
      obj.buyerCity = this.orderInfo.buyerCity;
      obj.buyerCountryCode = this.orderInfo.buyerCountryCode;
      obj.buyerEmail = this.orderInfo.buyerEmail;
      obj.buyerMobile = this.orderInfo.buyerMobile;
      obj.buyerName = this.orderInfo.buyerName;
      obj.buyerPassportCode = this.orderInfo.buyerPassportCode;
      obj.buyerPhone = this.orderInfo.buyerPhone;
      obj.buyerPostalCode = this.orderInfo.buyerPostalCode;
      obj.buyerState = this.orderInfo.buyerState;
      obj.despatchTime = null;
      obj.orderId = this.orderInfo.orderId;
      obj.orderShippingDetailList = null;
      obj.packageCreatedTime = null;
      obj.pickingStatus = null;
      obj.trackingNumberStatus = null;
      obj.warehouseId = null;
      let newList = [];
      const copyData = this.$common.copy(this.formData.talbeData);
      let newTotal = null;
      copyData.forEach(item => {
        newTotal = this.$common.isEmpty(item.reissueTotal) ? 0 : Number(item.reissueTotal);
        if (!this.$common.isEmpty(newTotal) && newTotal > 0) {
          item.quantity = newTotal;
          ['reissueTotal', 'sentTotal', 'unsentTotal'].forEach(key => {
            delete item[key];
          });
          if (!this.$common.isEmpty(item.productLength)) {
            item.productLength = Number(item.productLength);
          }
          if (!this.$common.isEmpty(item.productWidth)) {
            item.productWidth = Number(item.productWidth);
          }
          if (!this.$common.isEmpty(item.productHeight)) {
            item.productHeight = Number(item.productHeight);
          }
          item.addType = 1;
          newList.push(item);
        }
      });
      obj.orderShippingDetailList = newList;
      // // 这里是和物流方式有关，目前这里不用
      // if (obj.warehouseId && !this.$common.isEmpty(this.shippingMethodValue)) {
      //   obj.setShippingMethodOrderBo = {
      //     merchantCarrierId: this.shippingMethodValue[0],
      //     merchantShippingMethodId: this.shippingMethodValue[1],
      //     carrierAccountId: this.shippingAccountModel,
      //     packageCarrierParam: this.shippingMethodModel
      //   };
      // }
      return obj;
    },
    // 验证必填数据
    validFromData (data) {
      if (this.$common.isEmpty(data.orderShippingDetailList)) {
        this.$Message.error('补货商品数量不能全部都为 0 ');
        return false;
      }
      if (this.$common.isEmpty(data.buyerMobile) && this.$common.isEmpty(data.buyerPhone)) {
        this.$Message.error('收件人的手机号码或电话不能同时为空，请检查订单收件人信息');
        return false;
      }
      if (this.$common.isEmpty(data.buyerCity) && this.$common.isEmpty(data.buyerState)) {
        this.$Message.error('收件人地址省份或城市不能同时为空，请检查订单收件人信息');
        return false;
      }
      if (this.$common.isEmpty(data.buyerAddress1)) {
        this.$Message.error('收件人详细地址不能为空，请检查订单收件人信息');
        return false;
      }
      if (this.$common.isEmpty(data.buyerName)) {
        this.$Message.error('收件人姓名不能为空，请检查订单收件人信息');
        return false;
      }
      // if (this.$common.isEmpty(data.addressCode)) {
      //   this.$Message.error('收件人邮政编号不能为空，请检查订单收件人信息');
      //   return false;
      // }
      return true;
    },
    // 关闭弹窗
    closeModal () {
      // 取消对应还没有请求完成的请求
      this.cancelList.forEach(key => {
        this.$store.commit('cancelPending', key);
      });
      this.pageLoadTxt = '正在加载数据中...';
      this.$nextTick(() => {
        this.cancelList = [];
        this.isVisible = false;
      })
    },
  }
};
</script>
<style lang="less" scoped>
@labelWidth: 100px;
.modal-body-main{
  position: relative;
  .row-col-info{
    display: inline-block;
    padding: 0;
    margin: 0;
    width: 100%;
    text-align: left;
  }
  .grid-vertical-center {
    display: grid;
    align-items: center;
    grid-template-columns: auto 100px;
  }
  .product-sku-number{
    padding: 0 10px;
    font-size: 16px;
    text-align: right;
  }
}
</style>
<style lang="less">
.reissue-commodity{
  .ivu-modal{
    position: relative;
  }
}
</style>
